import { render, staticRenderFns } from "./ProviderWalletRequests.vue?vue&type=template&id=4cc032b8&scoped=true"
import script from "./ProviderWalletRequests.vue?vue&type=script&lang=js"
export * from "./ProviderWalletRequests.vue?vue&type=script&lang=js"
import style0 from "./ProviderWalletRequests.vue?vue&type=style&index=0&id=4cc032b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc032b8",
  null
  
)

export default component.exports